import React from 'react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, bonuses } from '../data/fono';
export function BonusSection() {
  return <section className="border-y-4 border-turq/30 bg-mint/50 px-3 py-5 sm:py-7" data-id="element-18" data-mp="1ofc8k2p3j7l6">
      <div className="mx-auto max-w-4xl" data-id="element-19" data-mp="22ebuh2l858dn">
        <h2 className="text-center text-xl leading-tight text-teal sm:text-3xl" data-id="element-20" data-mp="22dah2rgqk9sr">
          🎁 5 Professional Bonuses Included
        </h2>

        <div className="mt-3 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="1annwu0irel4q">
          {bonuses.map(bonus => <a key={bonus.num} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border border-turq/40 bg-white p-3.5 shadow-sm transition-colors duration-150 hover:border-coral" data-id="element-22" data-mp="15qno1huiz49x">
              <p className="text-[11px] font-extrabold uppercase tracking-wide text-coral" data-id="element-23" data-mp="1eo7r8wby7an6">
                🎁 Bonus {bonus.num}
              </p>
              <h3 className="mt-0.5 text-sm leading-tight text-teal" data-id="element-24" data-mp="mxtj7gqm8sjf">{bonus.title}</h3>
              <p className="mt-1.5 text-[13px] font-medium leading-snug text-charcoal/80" data-id="element-25" data-mp="29smi2omn81m1">
                {bonus.body}
              </p>
              <p className="mt-auto pt-2 text-[11px] font-extrabold uppercase tracking-wide text-turq" data-id="element-26" data-mp="2epla91mqxyhl">
                {bonus.kicker}
              </p>
            </a>)}
        </div>

        <CTAButton className="mx-auto mt-3 max-w-md" data-id="element-27" data-mp="2ogg0si70zk8u">
          🗣️ YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
      </div>
    </section>;
}